export default __webpack_public_path__ + "static/media/image1pro5.6faeec8b.jpeg";